<template>
  <node-view-wrapper as="div" class="image-container">
    <img
      class="tiptap-imagee"
      v-bind="node.attrs"
      ref="resizableImg"
      :draggable="isDraggable"
      :data-drag-handle="isDraggable"
    />
    <v-icon
      v-if="this.editor.options.editable && this.selected"
      class="ml-n3 resize-icon hidden"
      ref="icon"
      @mousedown="onMouseDown"
    >
      mdi-arrow-top-left-bottom-right-bold
    </v-icon>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper,
  },
  props: nodeViewProps,
  data: () => ({
    isResizing: false,
    lastMovement: {},
    count: 0,
  }),
  computed: {
    isDraggable() {
      return this.node?.attrs?.isDraggable;
    },
  },
  methods: {
    onMouseDown(e) {
      e.preventDefault();
      this.isResizing = true;
    //   window.addEventListener('mousemove', this.throttle(this.onMouseMove));
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    },
    onMouseUp(e) {
        const aspectRatio = this.$refs.resizableImg.width / this.$refs.resizableImg.height
        let nextX = e.x - this.lastMovement.x;
        const width = this.$refs.resizableImg.width + nextX;
        const height = this.$refs.resizableImg.width / aspectRatio;
        this.updateAttributes({ width, height });

      this.isResizing = false;
      this.lastMovement = {};
    //   window.removeEventListener('mousemove', this.throttle(this.onMouseMove));
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    },
    // throttle(fn, wait = 60, leading = true) {
    //   let prev, timeout, lastargs;
    //   return (...args) => {
    //     lastargs = args;
    //     if (timeout) return;
    //     timeout = setTimeout(
    //       () => {
    //         timeout = null;
    //         prev = Date.now()
    //         // let's do this ... we'll release the stored args as we pass them through
    //         fn.apply(this, lastargs.splice(0, lastargs.length));
    //         // some fancy timing logic to allow leading / sub-offset waiting periods
    //       },
    //       leading ? (prev && Math.max(0, wait - Date.now() + prev)) || 0 : wait
    //     );
    //   };
    // },
    onMouseMove(e) {
        // const aspectRatio = this.node?.attrs?.width / this.node?.attrs?.height
        // console.log(aspectRatio);
        // if (isNaN(aspectRatio)) {
        //     console.log(this.node?.attrs?.width, 'width');
        //     console.log(this.node?.attrs?.height, 'height');
        //     // return
        // }
        // const aspectRatio = this.$refs.resizableImg.width / this.$refs.resizableImg.height
        // console.log(aspectRatio);
        // if (isNaN(aspectRatio)) {
        //     console.log(this.$refs.resizableImg.width, 'width');
        //     console.log(this.$refs.resizableImg.height, 'height');
        //     // return
        // }
      e.preventDefault();
      if (!this.isResizing) {
        return;
      }
      if (!Object.keys(this.lastMovement).length) {
        this.lastMovement = { x: e.x, y: e.y };
        return;
      }
      if (e.x === this.lastMovement.x && e.y === this.lastMovement.y) {
        return;
      }
      let nextX = e.x - this.lastMovement.x;
    //   let nextY = e.y - this.lastMovement.y;
      const width = this.$refs.resizableImg.width + nextX;
    //   const height = this.$refs.resizableImg.width / aspectRatio;
      this.lastMovement = { x: e.x, y: e.y };
      this.updateAttributes({ width, height: 'auto' });
    },
  },
};
</script>

<style lang="scss" scoped>

.image-container:hover {
  .hidden {
    visibility: visible !important;
  }
}
.image-container {
  // overflow: hidden;
  // position: relative;
  clear: both;
  display: inline-block;
  max-width: 100%;
  outline-color: transparent;
  outline-style: solid;
  outline-width: 2px;
  transition: all .2s ease-in;
  position: relative;

  img {
    display: inline-block;
    float: none;
    margin: 0;
    max-width: 100%;
  }
}
.resize-icon {
  position: absolute;
  bottom: 0;
}
::v-deep.resize-icon {
  cursor: se-resize !important;
}
</style>